<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title style="font-size: 13px; margin-left: 10px; text-align: left;" [ngClass]="{'adjustedTitleFont': setting.configuration.uIoptions?.homePageOption == 10}">{{ title | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="false" [ngClass]="{'disable-background-color': !this.setting.UIshowBackground}">

  @if ((mobile  && !setting.navigationSetting) && setting.configuration.uIoptions) {
    <app-undocked-navigation-bar style="position: relative; z-index: 10;" [disabledOption]="title"></app-undocked-navigation-bar>
  }

  <div class="default-content">
    <!--<img class="center-block full-logo" logo />-->
    <img class="center-block full-logo" [src]="logo" />

    <br>

      <ion-button expand="block" (click)="goToLogin()">{{'Auth.Login' | translate }}</ion-button>
      <p class="text-center">{{'Auth.LogBackInMessage' | translate }}</p>

      <div class="login-register-seperator"></div>

      <ion-button expand="block" (click)="goToRegister()">
        {{ 'Auth.SignUp' | translate }}
      </ion-button>
      <a class="forgot-password-link notice-link" (click)="goToForgotPassword()">{{ 'Auth.ForgotPassword' | translate }}?</a>

      <p class="text-center">
        {{ 'Auth.LoginAgreementMessage' | translate}}
        <a class="notice-link" (click)="termsOfUse()">{{ 'Auth.TermsOfUse' | translate }}</a> {{ 'General.And' | translate | lowercase }} <a class="notice-link" target="_system" (click)="policies()">{{ 'Auth.PrivacyPolicy' | translate }}</a>
      </p>
    </div>
  </ion-content>